import ProductsSearchResultAdvancedView from './ProductsSearchResultAdvancedView'

export default ProductsSearchResultAdvancedView
